import { render, staticRenderFns } from "./BlockedContainer.vue?vue&type=template&id=7c821536&"
import script from "./BlockedContainer.vue?vue&type=script&lang=js&"
export * from "./BlockedContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports